import React, { useCallback, useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";
import dayjs from "dayjs";

// material-ui components
import ClearIcon from "@material-ui/icons/Clear";
import { makeStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import NavPills from "components/NavPillsCustom/NavPillsCustom.js";
import FormControl from "@material-ui/core/FormControl";
import Datetime from "react-datetime";

// custom components
import MapLateralMenuItem from "components/MapLateralMenuItem";
import CheckboxList from "components/CheckboxList/CheckboxList";
import HashLoader from "react-spinners/HashLoader";

// styles
import {
  ListStyled,
  Container,
  InfoHeader,
  InfoSeparator,
  InfoRow,
  TabWrapper,
} from "./styles";
import "./styles.css";
import { css } from "@emotion/core";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

// actions creators
import {
  REMOVE_SELECTED_UNIT,
  SET_SELECTED_UNITS,
  setRowChecked,
  getUnitDocuments,
} from "redux/ducks/mapPage";

// variables
import * as variables from "./variable";
import { configUnit } from "views/Map/MapPageConfig";
import { ACTIVE, CANCELED } from "views/Map/MapPageTypes";

// hooks
import { useClock } from "hooks/useClock";
import { useTimer } from "hooks/useTimer";

const useStyles = makeStyles(styles);

const override = css`
  display: block;
  margin: 2rem auto;
`;

const MapLateralMenu = ({
  isOpen,
  item,
  isLoading,
  colorRGB,
  color,
  isNote,
  onChangeDoctos,
  onOpenCancelModal,
  onClose,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const clock = useClock(60000);
  const [runTimer] = useTimer(1000);
  // local state
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [activeTab, setActiveTab] = useState(0);
  const [date, setDate] = useState(moment());

  // selector
  const selectedUnits = useSelector(
    (state) => state.map.selectedUnits,
    shallowEqual
  );
  const checked = useSelector((state) => state.map.checked, shallowEqual);

  const filterOrders = (item, checked) => {
    if (item) {
      if (
        checked.includes(variables.PENDING) &&
        checked.includes(variables.CANCEL)
      ) {
        return item.servicesList;
      }
      if (
        checked.includes(variables.PENDING) &&
        !checked.includes(variables.CANCEL)
      ) {
        return item.servicesList.filter((order) => order.status === ACTIVE);
      }
      if (
        !checked.includes(variables.PENDING) &&
        checked.includes(variables.CANCEL)
      ) {
        return item.servicesList.filter((order) => order.status === CANCELED);
      }
    }
    return [];
  };
  const filterNotes = (item, checked) => {
    if (item) {
      if (
        checked.includes(variables.ORDERS) &&
        checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList;
      }
      if (
        checked.includes(variables.ORDERS) &&
        !checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList.filter((note) => (note.account ? true : false));
      }
      if (
        !checked.includes(variables.ORDERS) &&
        checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList.filter((note) => (!note.account ? true : false));
      }
    }
    return [];
  };
  const notes = useMemo(() => filterNotes(item, checked, isLoading), [
    item,
    checked,
    isLoading,
  ]);
  const orders = useMemo(() => filterOrders(item, checked, isLoading), [
    item,
    checked,
    isLoading,
  ]);

  // handlers
  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    dispatch(setRowChecked(newChecked));
  };
  const handleChangeDate = (event) => {
    const { id } = item;
    const date = dayjs(event).format("YYYY-MM-DD");
    setDate(event);
    if (event) {
      runTimer(infoCall, [id, date]);
    }
  };

  const itemsCheckbox = [
    {
      title: "Pendientes",
      checkValue: checked.indexOf(variables.PENDING) !== -1 ? true : false,
      handler: () => handleToggle(variables.PENDING),
    },
    {
      title: "Cancelados",
      checkValue: checked.indexOf(variables.CANCEL) !== -1 ? true : false,
      handler: () => handleToggle(variables.CANCEL),
    },
  ];
  const itemsCheckboxSells = [
    {
      title: "Pedido",
      checkValue: checked.indexOf(variables.ORDERS) !== -1 ? true : false,

      handler: () => handleToggle(variables.ORDERS),
    },
    {
      title: "En ruta",
      checkValue: checked.indexOf(variables.ONTRANSIT) !== -1 ? true : false,
      handler: () => handleToggle(variables.ONTRANSIT),
    },
  ];
  const fieldRow = (row, clock, item) => {
    if (item) {
      if (row.isFunction) {
        const params = row.params.map((param) => item[param]);
        let propsParams = [];
        if (row.hasClock) {
          propsParams.push(clock);
        } else {
          propsParams = row.propsParams
            ? row.propsParams.map((param) => item[param])
            : [];
        }
        if (row.hasFormat) {
          params.push(row.formatParams);
          propsParams.push(row.formatPropsParams);
        }
        return row.fn(...params, ...propsParams);
      }
      if (row.field) {
        return row.isLength ? item[row.field].length : item[row.field];
      }
    }
    return "";
  };
  const infoCall = (id, date) => {
    dispatch(getUnitDocuments(id, date));
  };

  // calls
  const addSelectedUnit = useCallback(
    (id) => dispatch({ type: SET_SELECTED_UNITS, payload: id }),
    [dispatch]
  );
  const removeSelectedUnit = useCallback(
    (id) => dispatch({ type: REMOVE_SELECTED_UNIT, payload: id }),
    [dispatch]
  );

  setTimeout(function() {
    setCardAnimation("");
  }, 700);

  // effects
  useEffect(() => {
    const initalChecked = [
      variables.ONTRANSIT,
      variables.CANCEL,
      variables.ORDERS,
      variables.PENDING,
    ];
    dispatch(setRowChecked(initalChecked));
  }, [isOpen]);

  const renderView = ({ style, ...props }) => {
    return <ListStyled {...props} style={{ ...style }} />;
  };

  return (
    <div>
      {isOpen && (
        <>
          <Container>
            <Card className={`${classes[cardAnimaton]} ${classes.cardOverMap}`}>
              <CardBody>
                {item && (
                  <>
                    <InfoHeader>{item.number}</InfoHeader>
                    <InfoSeparator color={colorRGB} />
                  </>
                )}
                {configUnit.rows.length &&
                  configUnit.rows.map((row, index) => {
                    return (
                      <InfoRow key={`${row.text}-${index}`}>
                        <strong>{row.text}</strong>
                        {row.beforeText ? `${row.beforeText}` : ""}
                        {row.isClock ? clock : ""}
                        {fieldRow(row, clock, item)}
                        {row.afterText ? ` ${row.afterText}` : ""}
                      </InfoRow>
                    );
                  })}
                <InfoSeparator color={colorRGB} />
                <FormControl fullWidth>
                  <Datetime
                    timeFormat={false}
                    value={date}
                    inputProps={{ placeholder: "Date Picker Here" }}
                    onChange={handleChangeDate}
                  />
                </FormControl>
              </CardBody>
            </Card>
            <Card
              login
              className={`${classes[cardAnimaton]} ${classes.cardLateralMap}`}
            >
              <Button
                onClick={() => onClose()}
                size="sm"
                justIcon
                className={classes.mapLateralCloseButton}
                color={color}
                round
              >
                <ClearIcon />
              </Button>

              <CardBody className={classes.cardBody}>
                <HashLoader
                  css={override}
                  size={45}
                  color={`${colorRGB}`}
                  loading={isLoading}
                />
                {!isLoading && (
                  <NavPills
                    color={color}
                    activeTab={activeTab}
                    onChangeTab={setActiveTab}
                    tabs={[
                      {
                        tabButton: "Pedidos",

                        tabContent: (
                          <TabWrapper>
                            <CheckboxList
                              items={itemsCheckbox}
                              colorRGB={colorRGB}
                            />
                            <Scrollbars
                              className="scrollbar"
                              autoHide
                              renderView={renderView}
                            >
                              {orders.map((service, index) => (
                                <MapLateralMenuItem
                                  isNote
                                  colorRGB={colorRGB}
                                  unit={item}
                                  item={service}
                                  key={`${service.id}-${index}`}
                                  onOpen={addSelectedUnit}
                                  onClose={removeSelectedUnit}
                                  selectedUnits={selectedUnits}
                                  onOpenCancelModal={onOpenCancelModal}
                                />
                              ))}
                            </Scrollbars>
                          </TabWrapper>
                        ),
                      },
                      {
                        tabButton: "Ventas",
                        tabContent: (
                          <TabWrapper>
                            <CheckboxList
                              items={itemsCheckboxSells}
                              colorRGB={colorRGB}
                            />
                            <Scrollbars
                              className="scrollbar"
                              autoHide
                              renderView={renderView}
                            >
                              {notes.map((note, index) => (
                                <MapLateralMenuItem
                                  item={note}
                                  colorRGB={colorRGB}
                                  unit={item}
                                  key={`${note.id}-${index}`}
                                  onOpen={addSelectedUnit}
                                  onClose={removeSelectedUnit}
                                  selectedUnits={selectedUnits}
                                />
                              ))}
                            </Scrollbars>
                          </TabWrapper>
                        ),
                      },
                    ]}
                  />
                )}
              </CardBody>
            </Card>
          </Container>
        </>
      )}
    </div>
  );
};

export default React.memo(MapLateralMenu);
